export default __webpack_public_path__ + "static/img/vogue_scene_animated_0770.cc44c9d.webp";